import reducer from "./reducer";
export { default as ModulesAndMenus } from "./components/index";
export { default as modulesAndMenusReducerName } from "./constants";
export default reducer;
